import React from "react";
import { ListGroup, Button, Badge } from "react-bootstrap"; // <-- Badge agregado aquí

/**
 * Props:
 * - productos (array)
 * - onAgregar(product)
 */
export const ListaProductos = ({ productos, onAgregar }) => {
  return (
    <ListGroup variant="flush" style={{ maxHeight: 520, overflowY: "auto" }}>
      {productos.length === 0 && (
        <div className="text-center text-muted py-4">Sin productos</div>
      )}

      {productos.map((p) => (
        <ListGroup.Item key={p.id} className="d-flex justify-content-between align-items-center">
          <div style={{ minWidth: 0 }}>
            {/* 1. MOSTRAR NOMBRE Y ATRIBUTO */}
            <div className="fw-semibold d-flex align-items-center">
              {p.nombreProducto}
              {/* Mostramos el atributo/variante, solo si no es 'Único' */}
              {p.atributo && p.atributo !== 'Único' && (
                  <Badge bg="secondary" className="ms-2">{p.atributo}</Badge>
              )}
            </div>

            {/* 2. MOSTRAR CÓDIGOS Y DETALLES */}
            <div className="small text-muted">
              {/* Mostramos el SKU (codigoProducto) */}
              {p.codigoProducto ? `SKU: ${p.codigoProducto}` : "Sin código"} 
              
              {/* Mostramos el Código Padre, solo si es diferente al SKU */}
              {p.codigoPadre && p.codigoPadre !== p.codigoProducto && (
                  <span> • codPadre: {p.codigoPadre}</span>
              )}
              
              {/* Resto de los detalles */}
              <span className="ms-2">• {p.categoria || "Sin categoría"} • {p.proveedor || "Sin proveedor"}</span>
            </div>
          </div>

          <div className="text-end">
            {/* Formateamos el precio para moneda ARS */}
            <div className="fw-bold">
              {p.precioFinal 
                ? `ARS ${Number(p.precioFinal).toLocaleString('es-AR')}` 
                : `ARS ${Number(p.precioVenta || 0).toLocaleString('es-AR')}`
              }
            </div>
            
            <div className="small text-muted">{p.stock ?? 0} u.</div>
            <Button size="sm" variant="primary" className="mt-2" onClick={() => onAgregar(p)}>Agregar</Button>
          </div>
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
};